import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Logout.css";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const confirmation = window.confirm("Are you sure you want to logout..");
    console.log(confirmation);
    let isTokenDeleted = false;
    if (confirmation===true) {
      localStorage.removeItem("token");
      isTokenDeleted = true;
      console.log("jkhgbvhkl;l")
    }
    if (isTokenDeleted) {
      navigate("/");
      setTimeout(() => {
        window.location.reload("/");
      }, 200);
    }else{
      navigate('/')
    }
  }, []);

  return (
    <div id="logout-wrapper">
      <div className="logout-container">
        <h2>Logging Out...</h2>
        <p>You will be redirected shortly.</p>
      </div>
    </div>
  );
};

export default Logout;
